 /**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:56 2019-07-10
 */

 import { defaultNullValue } from 'src/config';
 import Api from 'src/util/api';
 import { PageDo, Result, ResultPageDo, Integer } from 'src/types/base';
 
export declare namespace MnManageDOI {
     export interface RowDataI {
         mn: string;
         create_time: string;
         company_unit: string;
         status: number;
         id: number;
     }
 
     export interface QueryRowDataParamsI extends PageDo {
        key_word?: string;
     }

     export interface FormDataI {
        mn: string;
        id: Integer;
        company_unit: Integer;
     }

     export interface OperateParamsI {
        id?     : Integer
        company_unit    : string
    }
}


export default class MnManageApi {
     /**
      * 查询列表
      * @param {GetPeopleManageListParamsI} params
      * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
      */
     static async searchList(params: MnManageDOI.QueryRowDataParamsI): Promise<ResultPageDo<MnManageDOI.RowDataI[]>> {
         return Api.post('/monitor/mn_manage/get/list', {
            key_word: '',
            ...params,
         });
     }

     static async add(data:MnManageDOI.FormDataI):Promise<Result<any>> {
		return Api.post('/monitor/mn_manage/add/mn', data)
	 }

    static async delete(mn: string):Promise<Result<any>> {
		return Api.post('/monitor/mn_manage/delete/mn', {mn})
    }

        /**
     * 修改
     * @param {UserConfigDOI.OperateParamsI} data
     * @returns {Promise<Result<any>>}
     */
    static async update(data: MnManageDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/monitor/mn_manage/edit/mn', data);
    }

    /**
     * 
     * @param user_id 查询详情
     * @returns 
     */
    static async searchDetail(id: number): Promise<Result<MnManageDOI.RowDataI[]>> {
        return Api.post('/monitor/mn_manage/detail/by/id', {id});
    }

 }
 